import { ResourceItem } from "../ResourceItem";
import _ from "lodash";
import { Komponent } from "./Komponent";
import { v4 as uuidV4 } from "uuid";
import Decimal from "decimal.js";
export interface IngredientsDiff {
  [ingredientsd: number]: boolean;
}

function ingredientArrayToDictionary(array: Ingredient[]): {
  [komponentId: number]: Ingredient;
} {
  const res: any = {};
  array.forEach((ingredient) => {
    res[ingredient.komponent!.id!] = ingredient;
  });
  return res;
}

export function getIngredientsDiff(a: Ingredient[], b: Ingredient[]) {
  const aDict = ingredientArrayToDictionary(a);

  const result: IngredientsDiff = {};

  a.forEach((s: Ingredient) => {
    result[s.komponent!.id!] = true;
  });

  b.forEach((s: Ingredient) => {
    const other = aDict[s.komponent!.id!];
    result[s.komponent!.id!] = other ? !s.massKg.equals(other.massKg) : true;
  });

  return result;
}

export class Ingredient {
  uuid!: string;
  komponent!: Komponent;
  massKg: Decimal = new Decimal(0);
  ingredientGroup: ResourceItem | null = null;
  roles: ResourceItem[] = [];

  cost?: Decimal;

  constructor(data?: any, komponent?: Komponent) {
    if (data) {
      this.uuid = data.uuid;
      this.komponent = new Komponent(data.komponent);
      this.massKg = new Decimal(data.massKg);
      this.ingredientGroup = data.ingredientGroup;
      this.roles = data.roles;

      this.cost = this.komponent
        ? this.massKg.mul(this.komponent.price)
        : undefined;
    }
    if (komponent) this.komponent = komponent;
    if (!data || !data.uuid) {
      this.uuid = uuidV4();
    }
  }

  getPostData() {
    return {
      komponent: { activeId: this.komponent!.activeId },
      massKg: this.massKg,
      uuid: this.uuid,
      roles: this.roles.map((x) => ({ id: x.id })),
      ingredientGroup: this.ingredientGroup
        ? { id: this.ingredientGroup.id }
        : null,
    };
  }
}

export const ingredientsTotalAmount = (ingredients: Ingredient[]): Decimal =>
  ingredients.reduce(
    (res, ingredient) => res.add(ingredient.massKg),
    new Decimal(0),
  ) || new Decimal(0);

export const ingredientsTotalPrice = (ingredients: Ingredient[]): Decimal => {
  const totalAmount = ingredientsTotalAmount(ingredients);

  if (totalAmount.equals(0)) return new Decimal(0);

  return ingredients
    .reduce(
      (res, ingredient) =>
        res.add(ingredient.komponent!.price.mul(ingredient.massKg)),
      new Decimal(0),
    )
    .div(totalAmount);
};
